<template>
  <div class="stage_data">
    <div v-if="stage.norm_stage == 1">
      <span class="label">
        Дата установки стадии:
      </span>
      <span class="date">
        {{ new Date( stage.date ) | dateFormat('DD.MM.YYYY')}}
      </span>
    </div>
    <div v-if="stage.norm_stage == 2">
      <span class="label">
        Дата начала разработки:
      </span>
      <span class="date">
        {{ new Date( stage.date ) | dateFormat('DD.MM.YYYY')}}
      </span>
    </div>
    <div v-if="stage.norm_stage == 3">
      <span class="label">
        Дата публикации:
      </span>
      <span class="date">
        {{ new Date( stage.date ) | dateFormat('DD.MM.YYYY')}}
      </span>
    </div>
    <div v-if="stage.norm_stage == 4">
      <span class="label">
        Дата исходящего документа:
      </span>
      <span class="date">
        {{ new Date( stage.date ) | dateFormat('DD.MM.YYYY')}}
      </span>
    </div>
    <div v-if="stage.norm_stage == 5">
      <span class="label">
        Дата принятия:
      </span>
      <span class="date">
        {{ new Date( stage.date ) | dateFormat('DD.MM.YYYY')}}
      </span>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'LawNormViewStageTableData',
    props: {
      stage: {
        type: Object,
        required: true
      }
    }
  }
</script>